import React from 'react'
import { detectInAppBrowserName, openInExternalBrowser, useCopyToClipboard } from 'utils'

// Note for the top of an auth form shown inside an in-app browser, in the slot
// the Google button would take. Google refuses OAuth there, so this is the way
// out for a reader who would rather use Google. It names the app the reader is
// in, because "in-app browser" means nothing to most of them.
export default function InAppBrowserNote({ mode = 'login', t = {} }) {
  const { copyToClipboard, isCopied } = useCopyToClipboard()
  const app = detectInAppBrowserName() || t.in_app_note_unknown_app || 'this app'
  const sentence = (mode === 'register' ? t.in_app_note_register : t.in_app_note_login) ||
    'Google login does not work in %{app}.'

  const handleOpen = async () => {
    const result = await openInExternalBrowser()
    if (result === null) copyToClipboard(window.location.href)
  }

  return (
    <div aria-live="polite" className="rounded-lg p-4 text-center" style={{ backgroundColor: '#E6F0FF' }}>
      <p className="text-sm font-medium text-gray-800">{sentence.replace('%{app}', app)}</p>
      <button
        type="button"
        onClick={handleOpen}
        className="mt-3 w-full min-h-[44px] rounded-lg border bg-white px-4 text-sm font-medium transition-colors hover:bg-blue-50 cursor-pointer"
        style={{ borderColor: '#3366FF', color: '#3366FF' }}
      >
        {isCopied
          ? (t.in_app_copied_hint || 'Copied! Paste in Safari or Chrome')
          : (t.in_app_note_action || 'Open in browser to use Google')}
      </button>
    </div>
  )
}
